import {
  PREMIUM_ESRI_MAP,
  PREMIUM_GIS_SERVICES,
} from '@rsos/constants/permissions';
import { notifyError } from '@rsos/utils/toastUtils';

const errorMessage =
  'GIS Services require access to Esri Map to operate. Please enable access to the Esri Map data source first.';

const premiumPermissions = [PREMIUM_GIS_SERVICES];

/**
 * Determines if the permissions contain premium permissions.
 * @param {Array} permissions - List of permissions.
 * @returns Boolean
 */
const hasPremiumPermissions = permissions =>
  permissions &&
  premiumPermissions.some(premiumPermission =>
    permissions.includes(premiumPermission),
  );

/**
 * Determines if the permissions contain required permissions.
 * @param {Array} permissions - List of permissions.
 * @returns Boolean
 */
const hasRequiredPermissions = permissions =>
  permissions && permissions.includes(PREMIUM_ESRI_MAP);

/**
 * Determines if the assigned premium permissions have the required permission(s) to ensure the
 * feature or data source works properly.
 * @param {Array} allRoles - All the roles in the current agency.
 * @param {Array} assignedPermissions - The permissions that will be assigned to the roles.
 * @param {Array} assignedRoleIds - The role id's that the permissions will be assigned to.
 * @returns Boolean
 */
export const checkPremiumPermissions = ({
  allRoles,
  assignedPermissions,
  assignedRoleIds,
}) => {
  let missingRequiredPermissions = false;

  // Permission handling for DataSourcesForm.js
  if (
    allRoles &&
    assignedRoleIds &&
    hasPremiumPermissions(assignedPermissions)
  ) {
    missingRequiredPermissions = !!assignedRoleIds.find(id =>
      allRoles.find(
        role =>
          id === role.id &&
          !hasRequiredPermissions(assignedPermissions) &&
          !hasRequiredPermissions(role.permissions),
      ),
    );
  }
  // Permission handling for AddRoleModal.js
  else if (
    hasPremiumPermissions(assignedPermissions) &&
    !hasRequiredPermissions(assignedPermissions)
  ) {
    missingRequiredPermissions = true;
  }

  return missingRequiredPermissions;
};

/**
 * Creates an error toast notification.
 */
export const notifyMissingRequiredPermissions = () => notifyError(errorMessage);
